import { chain } from 'lodash';

export const getProvinceAndLocalityName = (provinces, provinceID, localityID) => {
  return chain(provinces)
    .find(['value', provinceID])
    .thru(provinceObject => {
      const domicilioLabel = chain(provinceObject)
      .get('onlyThisLocalities')
      .find(['value', localityID])
      .get('domicilio', '')
      .value();
      const domicilioLocalidad = chain(provinceObject)
      .get('onlyThisLocalities')
      .find(['value', localityID])
      .get('domicilio.localidad', '')
      .value();
      const officeNameLabel = chain(provinceObject)
      .get('officeName')
      .value();
      const zonaId = chain(provinceObject)
      .get('idAdminMop')
      .value();
      const planA = chain(provinceObject)
      .get('planAdi')
      .value();
      return [domicilioLabel, domicilioLocalidad, officeNameLabel, zonaId, planA];
    });
};